// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2uYR4","location":"Header_location__2HjoH"};